import { useEffect, useMemo, useState } from "react"
import DocumentList from "../../../components/WelcomeKit/DocumentList";
import WelcomeNote from "../../../components/WelcomeKit/WelcomeNote";
import { callautopopulate } from "../../../services/callautopop";
import DetailsForm from "../../../components/WelcomeKit/DetailsForm";
import FormTable from "../../../components/WelcomeKit/FormTable";
import DisclosureAgreement from "../../../components/WelcomeKit/DisclosureAgreement";
import _ from "underscore";
import ReleaseForm from "../../../components/WelcomeKit/ReleaseForm";
import PolicyAcknowledgment from "../../../components/WelcomeKit/PolicyAcknowledgment";
import FeedbackForm from "../../../components/WelcomeKit/FeedbackForm";
import StationHouse from "../../../components/WelcomeKit/StationHouse";
import JoiningReport from "../../../components/WelcomeKit/JoiningReport";
import LeaveTravel from "../../../components/WelcomeKit/LeaveTravel";
import ProvidentFund from "../../../components/WelcomeKit/ProvidentFund";
import ProvidentFundDeclaration from "../../../components/WelcomeKit/ProvidentFundDeclaration";
import GratuityNomination from "../../../components/WelcomeKit/GratuityNomination";
import { useCommanKit } from "./useCommanKit";
import ESICDeclaration from "../../../components/WelcomeKit/ESICDeclaration";
import AssetAllocation from "../../../components/WelcomeKit/AssetAllocation";

export const useMultiStepForm = () => {

    const initialFormData = {};

    const steps = [
        { label: 'step1', component: WelcomeNote },
        { label: 'step2', component: DocumentList },
        { label: 'step3', component: DetailsForm },
        { label: 'step4', component: FormTable },
        { label: 'step5', component: FormTable },
        { label: 'step6', component: DetailsForm },
        { label: "step7", component: JoiningReport },
        { label: 'step8', component: FormTable },
        { label: 'step9', component: LeaveTravel },
        { label: 'step10', component: FormTable },
        { label: 'step11', component: ProvidentFundDeclaration },
        { label: 'step12', component: ProvidentFund },
        { label: 'step13', component: ESICDeclaration },
        { label: "step14", component: GratuityNomination },
        { label: 'step15', component: DisclosureAgreement },
        { label: 'step16', component: AssetAllocation },
        { label: "step17", component: DetailsForm },
        { label: "step18", component: FeedbackForm },
        { label: 'step19', component: ReleaseForm },
        { label: "step20", component: PolicyAcknowledgment },
        { label: "step21", component: StationHouse }

    ];
    const [currentStep, setCurrentStep] = useState(0);
    const [formData, setFormData] = useState(initialFormData);
    const [data, setData] = useState({});
    const { getEmployeeDetails } = useCommanKit({ data });

    useEffect(() => {
        callautopopulate("user_info", "users", "attribute_items", "attribute_group").then((res) => {
            const hrData = _.findWhere(res?.users, { user_category_key: "hr-leads" })
            callAPI(res?.user_info?.[0]?.user_code)
            setData({ employee: res?.user_info?.[0], director: "Akshay Dholakia", hrData, attributeGroup: res?.attribute_group, attributeItems: res?.attribute_items });
        })
    }, []);

    useEffect(() => {
        scrollToTop();
    }, [currentStep]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    const StepComponent = steps[currentStep].component;

    const nextStep = () => setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1));

    const prevStep = () => {
        setCurrentStep((prev) => Math.max(prev - 1, 0));
    }

    const handleChange = (data) => {
        setFormData((prev) => ({ ...prev, ...data }));
    };

    const callAPI = (id) => {
        getEmployeeDetails("users_common_details", id).then((res) => {
            setData((prev) => ({ ...prev, commonDetails: res?.users_common_details[0], hrSignature: res?.hr_lead_signature[0] }))
        }).catch((error) => {
            console.error(error)
        })
    }

    useEffect(() => {
        if (currentStep === 3) {
            callAPI(data?.employee?.user_code)
        }
    }, [currentStep])


    return useMemo(() => ({
        StepComponent, nextStep, prevStep, handleChange, formData, currentStep, steps, data
    }), [StepComponent, nextStep, prevStep, handleChange, formData, currentStep, steps, data])
}